import videoPlayer from './player'

export default videoPlayer;